// extracted by mini-css-extract-plugin
export default {"nevergreen":"nevergreen-nevergreen-VN0HY3"};